import axios from "axios"
import { Service } from "../services/Service"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL
class ActivitiesApi {
    public static async getActivities(
        format: string,
        userId: string,
        startDate?: string,
        endDate?: string
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/activities/${userId}?format=${
                format === "html" ? format : "raw"
            }${startDate ? `&startDate=${startDate}` : ""}${
                endDate ? `&endDate=${endDate}` : ""
            }`,
            {
                headers,
            }
        )
        return response
    }
}

export default ActivitiesApi
